import React, { useEffect, useRef, useState } from 'react';
import SVGComponent from '../SVGComponents/SVGComponents';

export default (props) => {
  const {
    column,
    showColumnMenu,
    setSort,
    displayName,
    enableSorting,
    enableMenu,
  } = props;
  const [ascSort, setAscSort] = useState('inactive');
  const [descSort, setDescSort] = useState('inactive');
  const [noSort, setNoSort] = useState('inactive');
  const [filter, setFilter] = useState(false);

  const refButton = useRef(null);

  const onMenuClicked = () => {
    showColumnMenu(refButton.current);
  };

  const onSortChanged = () => {
    setAscSort(column.isSortAscending() ? 'active' : 'inactive');
    setDescSort(column.isSortDescending() ? 'active' : 'inactive');
    setNoSort(
      !column.isSortAscending() && !column.isSortDescending()
        ? 'active'
        : 'inactive'
    );
  };

  const onSortRequested = (order, event, fromKeyDown = false) => {
    if (fromKeyDown) {
      setSort(order, false);
    } else {
      setSort(order, event.shiftKey);
    }
  };

  useEffect(() => {
    column.addEventListener('sortChanged', onSortChanged);
    onSortChanged();
    column.addEventListener('filterChanged', () => {
      setFilter(column.isFilterActive());
    });
  }, []);
  React.useLayoutEffect(() => {
    setFilter(column.isFilterActive());
  }, []);
  let menu = null;
  if (enableMenu) {
    menu = (
      <div
        ref={refButton}
        className='customHeaderMenuButton'
        onClick={() => onMenuClicked()}
        tabIndex={0}
      >
        <span>
          {column.isFilterActive() ? (
            <SVGComponent iconName='Icon-filter' />
          ) : (
            <SVGComponent iconName='Icon-filter-list' />
          )}
        </span>
      </div>
    );
  }

  let sort = null;
  if (enableSorting) {
    if (ascSort == 'active') {
      sort = (
        <div
          onClick={(event) => onSortRequested('desc', event)}
          className={`customSortUpLabel ${descSort}`}
        >
          <span>&#8593;</span>
        </div>
      );
    } else {
      sort = (
        <div
          onClick={(event) => onSortRequested('asc', event)}
          className={`customSortUpLabel ${ascSort}`}
        >
          <span> &#8595;</span>
        </div>
      );
    }
  }

  let star = null;
  if (
    displayName == 'Code Value' ||
    displayName == 'Contact type cd' ||
    column?.colDef?.required
  ) {
    star = (
      <div className='customSortRemoveLabelStar'>
        <span> * </span>
      </div>
    );
  }
  useEffect(() => {
    const selectAllElement = document.getElementsByClassName(
      'ag-header-select-all'
    );
    for (let i = 0; i < selectAllElement.length; i++) {
      const elementAll = selectAllElement[i]?.children[1]?.children[0] || [];
      const element = elementAll;
      const parent = element.parentNode;

      if (element?.nodeName !== 'LABEL') {
        const wrapper = document.createElement('label');
        wrapper.style.marginTop = '9px';
        wrapper.className = 'ag-checkbox-input-wrapper';
        parent.replaceChild(wrapper, element);
        wrapper.appendChild(element);
        const hiddenElement = document.createElement('span');
        hiddenElement.innerText = 'hidden label';
        hiddenElement.style.display = 'none';
        wrapper.appendChild(hiddenElement);
      }
    }
  }, []);

  const handleColumnClick = (event) => {
    if (event.key === 'Enter' && event.shiftKey) {
      onSortRequested(ascSort === 'active' ? 'desc' : 'asc', event, true);
    }
    if (event.key === 'Enter' && event.ctrlKey) {
      onMenuClicked();
    }
  };
  return !column?.colDef?.removeColumn ? (
    <div
      className='custom-column-header'
      tabIndex={0}
      onKeyDown={handleColumnClick}
    >
      <div className='customHeaderLabel'>{displayName}</div>
      {sort}{' '}
      {column?.colDef?.hideFilterIcon || column?.colDef?.showCheckboxIcon
        ? ''
        : menu}
      {star}
    </div>
  ) : null;
};
